import { useEffect, useState } from "react";
import ReportMemberShipDetails from "./ReportMemberShipDetails";
import { getTodayMonth} from '../../../../utils/Date/SupportDate';

import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, Pie  } from 'react-chartjs-2';

import { useSelector } from "react-redux";

function ReportMemberShipAdmin() {
  console.log("vo here membership admin")
    const [typeViewAreaBranch, setTypeViewAreaBranch] = useState("Branch");
    const [dataBranch, setDataBranch] = useState({
        area: "Select Area",
        branch: "Select Branch",
        branchID: 0,
        month: getTodayMonth()
    });

    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);
    // const allBranchInform = useSelector(state => state.allBranchInformation);
    const reportTotalRedux = useSelector(state => state.reportTotal);
    const { memberShip, isLoading } = reportTotalRedux;

    useEffect(()=>{

    },[token, auth, memberShip, isLoading])

    // const { role, area, branchID } = auth.user;
    // const isMultiBranch = (role === 5 || role === 6 || role === 7 || role === 8 || role === 1);
    // const isMultiArea = (role === 7 || role === 1 || role === 8);

    // const listArea = allBranchInform === undefined ? [] : Object.keys(allBranchInform);

    // const percent = viewRoom.percent;

    // ChartJS.register(ArcElement, LinearScale, BarElement, Tooltip, Legend,  );
    ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
    const data = {
        labels: memberShip.dataChartLoginTypeTitle,
        datasets: [
          {
            label: 'User Distribution',
            data: memberShip.dataChartLoginTypeData, // Số liệu mẫu
            backgroundColor: [
              '#FF6384', // Email: Hồng
              '#36A2EB', // Google: Xanh dương
              '#FFCE56', // Apple: Vàng
              '#4BC0C0', // Line: Xanh lam
              '#9966FF', // Facebook: Tím
            ],
            hoverOffset: 20,
          },
        ],
      };

      const options2 = {
        responsive: false,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Bar Chart Example',
          },
        },
        scales: {
          x: {
            type: 'category', // Đảm bảo trục x sử dụng category scale
          },
          y: {
            type: 'linear', // Trục y sử dụng linear scale
          },
        },
      };

    const options = {
        plugins: {
          legend: {
            position: 'right',
            labels: {
              font: {
                size: 14,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
          // Plugin tùy chỉnh để hiển thị số liệu trực tiếp
          datalabels: {
            formatter: (value, context) => {
              const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
              const percentage = ((value / total) * 100).toFixed(1) + '%';
              return `${value}(${percentage})`; // Hiển thị cả giá trị và phần trăm
            },
            color: '#fff', // Màu chữ
            textAlign: 'center',
            font: {
              weight: 'bold',
              size: 12,
            },
          },
        },
        maintainAspectRatio: true, // Bật để giữ tỷ lệ
        aspectRatio: 1, // Tỷ lệ 1:1 để biểu đồ tròn
        responsive: true, // Đảm bảo biểu đồ phản hồi với kích thước container
      };
      
      // Plugin tùy chỉnh để vẽ số liệu
  const customDataLabels = {
    id: 'customDataLabels',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((element, index) => {
          const { x, y } = element.tooltipPosition();
          const value = dataset.data[index];
          const total = dataset.data.reduce((sum, val) => sum + val, 0);
          const percentage = ((value / total) * 100).toFixed(1) + '%';
          const text = `${value}\n(${percentage})`; // (${percentage})

          ctx.save();
          ctx.fillStyle = '#fff'; // Màu chữ
          ctx.font = 'bold 12px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(text, x, y);
          ctx.restore();
        });
      });
    },
  };

  // Dữ liệu cho Bar Chart (Sales Data)
  const barData = {
    labels: [  "Jan", "Feb", "Mar", "Apr", "May", "Jun",  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: 'Membership register',
        data:  isLoading ? [] : memberShip.registrationsByYearOrdered["2025"],
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Sales Data 2025',
      },
    },
    scales: {
      x: {
        type: 'category',
      },
      y: {
        type: 'linear',
        beginAtZero: true,
      },
    },
  };

  const barData2 = {
    labels: ['18 old', '20-30 old', '30-40 old', '40-50 old', 'over'],
    datasets: [
      {
        label: 'Age member',
        data: memberShip.dataChartAreaGroupData,
        backgroundColor: 'rgba(54, 162, 235, 0.6)', // Màu xanh dương nhạt
        borderColor: 'rgba(54, 162, 235, 1)', // Viền màu xanh đậm
        borderWidth: 1,
      },
    ],
  };

  const barOptions2 = {
    indexAxis: 'y', // Xoay trục để tạo Horizontal Bar Chart
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: 'Headcount by Education',
      },
    },
    scales: {
      x: {
        type: 'linear',
        beginAtZero: true,
      },
      y: {
        type: 'category',
      },
    },
  };
  
  return !isLoading && <div style={{background:'#dee2e6', width:'80%'}}>
        <h1>Report Member ship</h1>
        <div className="d-flex">
          <ReportMemberShipDetails 
              title={{row1:"TOTAL", row2:"MEMBERSHIP"}}
              data={{number: Number(memberShip.genderCounts.Male) + Number(memberShip.genderCounts.Female) + Number(memberShip.genderCounts.Other)}}
          />
          <div style={{ width: '100%'}}>
              <Pie  options={options} 
              plugins={[customDataLabels]}
              data={data} style={{width:"500px"}}/> 
          </div>

          <div style={{ width: '100%'}}>
              <Bar data={barData} options={barOptions} style={{width:"400px"}}/>
          </div>

          {/* Bar Chart */}
          {/* <div className="w-full max-w-2xl p-6 bg-white rounded-lg shadow-lg">
              <div style={{ position: 'relative', width: '100%', height: '400px' }}>
              <Bar data={barData} options={barOptions} />
              </div>
          </div> */}
      </div>

      <div className="d-flex">
          <div>
              <ReportMemberShipDetails 
                  title={{row1:"MEMBERSHIP", row2:"INFORMATIOn"}}
                  data={{number: ""}}
              />
          </div>
          <div>
              <div className="d-flex">
                  <img src="https://azumayavietnam.com/image/other/male.png" width={30}></img>
                  <label style={{fontSize:'2rem'}}  className="mt-3">{memberShip.genderCounts.Male}</label>
              </div>
              <div className="d-flex">
                  <img src="https://azumayavietnam.com/image/other/female.png" width={30}></img>
                  <label style={{fontSize:'2rem'}} className="mt-3">{memberShip.genderCounts.Female}</label>
              </div>
              <div className="d-flex">
                  <div style={{fontSize:'1.2rem'}} >Other:</div>
                  <label style={{fontSize:'2rem'}} className="mt-3">{memberShip.genderCounts.Other}</label>
              </div>
          </div>


          <div style={{ width: '',  }} className="ml-3">
                  <Bar data={barData2} options={barOptions2} style={{width:"500px"}}/>
              </div>

          <div
              style={{
                  background: 'aqua',
                  marginLeft:'12px',
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  padding: '6px', // thêm nếu cần wrap text
                  border:'4px solid red',
                  fontSize: '12px' // để tránh chữ tràn   
              }}>
              <strong>Booking by App: {memberShip.countBookingByMemberShip}</strong>
          </div>  
      </div>

      <div className="d-flex mt-3">
          <div
              style={{
                  background: 'yellow',
                  marginLeft:'12px',
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  padding: '6px', // thêm nếu cần wrap text
                  border:'4px solid red',
                  fontSize: '12px' // để tránh chữ tràn   
              }}>
              <strong>Az Coin Return {Math.round(memberShip.totalAzCoin*100,2)/100}</strong>
          </div>   
          <div className="ml-3">
              <table style={{ borderCollapse: 'collapse', width: '100px', fontFamily: 'Arial, sans-serif', textAlign: 'center' }}>
                  <thead>
                      <tr>
                      <th colSpan="2" style={{ backgroundColor: 'yellow', fontWeight: 'bold', padding: '5px', fontSize: '1.2rem',border: '1px solid black' }}>
                          Rank Count
                      </th>
                      </tr>
                  </thead>
                  <tbody>
                      {[
                      ['Bronze', memberShip.rankTypeCounts.bronze || 0],
                      ['Sliver', memberShip.rankTypeCounts.silver || 0],
                      ['Gold', memberShip.gold || 0],
                      ['Platium', memberShip.platium || 0],
                      ['Diamond', memberShip.diamond || 0]
                      ].map(([rank, count]) => (
                      <tr key={rank}>
                          <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left', width: '80px'
                            }}>{rank}</td>
                          <td style={{ border: '1px solid black', padding: '5px',width: '30px' }}>{count}</td>
                      </tr>
                      ))}
                  </tbody>
              </table>
          </div>
          <div className="ml-3">
              <table style={{ borderCollapse: 'collapse', width: '400px', fontFamily: 'Arial, sans-serif', textAlign: 'center' }}>
                  <thead>
                      <tr>
                          <th colSpan="4" style={{ backgroundColor: 'yellow', fontWeight: 'bold', padding: '5px', fontSize: '1.2rem',border: '1px solid black' }}>
                              Member Ship Keeep Az Coin top
                          </th>
                      </tr>
                        <tr>
                          <th style={{ backgroundColor: 'yellow', fontWeight: 'bold', padding: '5px', fontSize: '1.2rem',border: '1px solid black' }}>
                              No.
                          </th>
                          <th style={{ backgroundColor: 'yellow', fontWeight: 'bold', padding: '5px', fontSize: '1.2rem',border: '1px solid black' }}>
                              name
                          </th>
                          <th style={{ backgroundColor: 'yellow', fontWeight: 'bold', padding: '5px', fontSize: '1.2rem',border: '1px solid black' }}>
                              Az Coin
                          </th>
                          <th style={{ backgroundColor: 'yellow', fontWeight: 'bold', padding: '5px', fontSize: '1.2rem',border: '1px solid black' }}>
                              Mail
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      {
                      // [
                      // ['E04', 1, 'it@azumayavietnam.com'],
                      // ['G27', 2, 'it3@azumayavietnam.com'],
                      // ['A00', 3, 'han@azumayavietnam.com'],
                      // ['A100', 1, 'it4@azumayavietnam.com'],
                      // ['A100', 5, 'it2@azumayavietnam.com'],
                      // ['A100', 5, 'it2@azumayavietnam.com'],
                      // ['A100', 5, 'it2@azumayavietnam.com'],
                      // ['A100', 5, 'it2@azumayavietnam.com'],
                      // ['A100', 5, 'it2@azumayavietnam.com'],
                      // ['A100', 5, 'it2@azumayavietnam.com'],
                      // ]email
                      memberShip.top10AzCoinUsers
                      .map(({name, azCoin, email}, index) => (
                      <tr key={email}>
                          <td style={{ border: '1px solid black', padding: '5px',width: '30px' }}>{index+1}</td>
                          {/* <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left', width: '60px'
                            }}>{userId}</td> */}
                            <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left', width: '60px'
                            }}>{name}</td>
                          <td style={{ border: '1px solid black', padding: '5px',width: '70px' }}>{azCoin}</td>
                          <td style={{ border: '1px solid black', padding: '5px',width: '200px' }}>{email}</td>
                      </tr>
                      ))}
                  </tbody>
              </table>
          </div>
      </div>
  
  </div>
}

export default ReportMemberShipAdmin;